import { render } from "./SingleVoucherForm.vue?vue&type=template&id=5afbd379&scoped=true"
import script from "./SingleVoucherForm.vue?vue&type=script&lang=ts"
export * from "./SingleVoucherForm.vue?vue&type=script&lang=ts"

import "./SingleVoucherForm.vue?vue&type=style&index=0&id=5afbd379&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5afbd379"

export default script